/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {
  ProfileDetailData,
  WhiteLabelProfileData,
} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  whiteLabelList: [],
}

export const CreateWhiteLabel: any = createAsyncThunk(
  '/CreateWhiteLabel',
  async (data: any, thunkApi: any) => {
    thunkApi.dispatch(startLoadding())
    const response: any = await axios.post(`${API_URL}admin/createWhiteLabel`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(GetAllWhiteLabel())

    return response.data
  }
)

export const GetAllWhiteLabel: any = createAsyncThunk(
  '/GetAllWhiteLabel',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/listWhiteLabelUsers`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())

    return response.data
  }
)

export const UpdateWhiteLabel: any = createAsyncThunk(
  '/UpdateWhiteLabel',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.put(
      `${API_URL}admin/updateWhiteLabel/${data?.id}`,
      data.data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllWhiteLabel({page: data.page}))
    thunkApi.dispatch(WhiteLabelProfileData(data.id))

    return response.data
  }
)

export const DeleteWhitelableUser: any = createAsyncThunk(
  '/DeleteWhitelableUser',
  async (data: any, thunkApi) => {
    const response: any = await axios.put(`${API_URL}admin/deleteWhiteLabel/${data.id}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllWhiteLabel())

    return response.data
  }
)
export const UpdateStatus: any = createAsyncThunk(
  '/updateStatus',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updateStatus`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllWhiteLabel())
    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }
    return response.data
  }
)
export const updatePassword: any = createAsyncThunk(
  '/updatePassword',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updatePassword`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(GetAllWhiteLabel())

    return response.data
  }
)

const WhiteLabelSlice = createSlice({
  name: 'WhiteLabelSlice',
  initialState,
  reducers: {},
  extraReducers: {
    [GetAllWhiteLabel.fulfilled]: (state, {payload}) => {
      return {...state, whiteLabelList: payload?.data}
    },
    [CreateWhiteLabel.fulfilled]: (state, {payload}) => {
      {
        payload.status === true && toast.success(payload.message)
      }
    },
  },
})

export const getWhiteLableList = (state: any) => state?.whiteLabelList?.whiteLabelList

export default WhiteLabelSlice.reducer
